import type { ID } from '@octopus-do/octopus-project-core'
import { createAction } from '@reduxjs/toolkit'

import type { TemplatesLists } from './types'

export interface SaveTemplatePayload {
  projectId: ID
  name: string
  // The workspace the template lands in: PERSONAL_WORKSPACE_ID or a team id.
  workspaceId: ID
}

export const TemplatesActions = {
  fetch: createAction<{ workspaceId: ID }>('TEMPLATES_FETCH'),
  use: createAction<{ id: ID; workspaceId: ID }>('TEMPLATES_USE'),
  delete: createAction<{ id: ID }>('TEMPLATES_DELETE'),
  save: createAction<SaveTemplatePayload>('TEMPLATES_SAVE'),
}

export const InternalTemplatesActions = {
  set: createAction<TemplatesLists>('TEMPLATES_SET'),
  remove: createAction<ID>('TEMPLATES_REMOVE'),
  saveFailed: createAction<string>('TEMPLATES_SAVE_FAILED'),
  saveReset: createAction('TEMPLATES_SAVE_RESET'),
}
